let embeddedMode = {
    runsInEmbeddedMode: !!JSON.parse(localStorage.getItem('runInEmbeddedMode')),
    wasSwitchedOff: false,
    wasSwitchedOn: false
}

export function detectIfAppRunsInEmbeddedMode() {
    const params = new URLSearchParams(window.location.search)
    if (!params.has('embedded')) {
        return
    }

    const runInEmbeddedMode = params.get('embedded')
    if (runInEmbeddedMode === '1') {
        localStorage.setItem('runInEmbeddedMode', JSON.stringify(true))
        if (!embeddedMode.runsInEmbeddedMode) {
            embeddedMode.wasSwitchedOn = true
        }
        embeddedMode.runsInEmbeddedMode = true
        return
    }
    if (runInEmbeddedMode === '0') {
        localStorage.setItem('runInEmbeddedMode', JSON.stringify(false))
        if (embeddedMode.runsInEmbeddedMode) {
            embeddedMode.wasSwitchedOff = true
        }
        embeddedMode.runsInEmbeddedMode = false
        return
    }
}

export function getEmbeddedMode() {
    return embeddedMode
}

export function runsInEmbeddedMode() {
    return !!JSON.parse(localStorage.getItem('runInEmbeddedMode'))
}